import React, { useEffect, useState } from 'react'

import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap'
import moment from 'moment';

// @constantes
import { CAMPOS_PROGRAMA, LABELS_PROGRAMA } from './constantes'
import { FORMATO_FECHA_DEFECTO } from 'utils/date';
import { FileUpload } from 'components/FileUpload/FileUpload';

export const ProgramaAcreditacionCalidad = ({
  navigation,
  programaAcademico,
  actualizarProgramaAcademico,
  guardarPrograma
}) => {
  /**
   * valores iniciales
   */
   const fechaDefecto = moment().format(FORMATO_FECHA_DEFECTO)
  const fechaVencimientoDefecto = moment(programaAcademico[CAMPOS_PROGRAMA.RC_FECHA_REGISTRO])
    .add(1, 'days').format(FORMATO_FECHA_DEFECTO)

  /**
   * Stados
   */
  const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(true)

  /**
   * Efectos
   */
   useEffect(() => {
    const campoSinLlenar =
      !programaAcademico[CAMPOS_PROGRAMA.AP_FECHA_REGISTRO]
      || !programaAcademico[CAMPOS_PROGRAMA.AP_FECHA_VENCIMIENTO]
      || !programaAcademico[CAMPOS_PROGRAMA.AP_RESOLUCION]
      || (!programaAcademico[CAMPOS_PROGRAMA.AP_FILES] && !programaAcademico.id)
    
      setDeshabilitarBotonGuardar(campoSinLlenar)
   }, [programaAcademico])
  
  useEffect(() => {
      actualizarProgramaAcademico(estadoPrevio => ({
        ...estadoPrevio,
        [CAMPOS_PROGRAMA.AP_FECHA_REGISTRO]: fechaDefecto,
        [CAMPOS_PROGRAMA.AP_FECHA_VENCIMIENTO]: fechaVencimientoDefecto
      }))
  }, [actualizarProgramaAcademico, fechaDefecto, fechaVencimientoDefecto]);

  /**
   * Manejadores
   */
   const manejadorDeCambios = (campo, valor) => {
    actualizarProgramaAcademico(estadoPrevio => ({
      ...estadoPrevio,
      [campo]: valor
    }))
  }
  
  const manejadorFechaAcreditacion = ({ target: { value } }) => {
    manejadorDeCambios(CAMPOS_PROGRAMA.AP_FECHA_REGISTRO, value)
  }

  const manejadorFechaVencimiento = ({ target: { value } }) => 
    manejadorDeCambios(CAMPOS_PROGRAMA.AP_FECHA_VENCIMIENTO, value)
  
  const manejadorResolucion = ({ target: { value } }) => 
    manejadorDeCambios(CAMPOS_PROGRAMA.AP_RESOLUCION, value)

  const manejadorAnios = ({ target: { value } }) => {
    const parsedValue = parseInt(value);
    if (parsedValue < 0) {
      return
    }
    manejadorDeCambios(CAMPOS_PROGRAMA.AP_ANIOS, value)
  }
  
  const manejadorArchivos = ({ target: { files } }) => 
    manejadorDeCambios(CAMPOS_PROGRAMA.AP_FILES, files[0])

  const manejadorGuardar = () => guardarPrograma(navigation)

  return (
    <div className='container mb-3'>
      <h2>Resolución de acreditación de calidad del programa</h2>
      <Form className='mt-4'>
        <Row form>
          <Col md={5} className='mr-4'>
            <FormGroup>
              <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.AP_FECHA_REGISTRO]} *</Label>
              <Input
                type='date' 
                placeholder='NA'
                onChange={manejadorFechaAcreditacion}
                value={programaAcademico[CAMPOS_PROGRAMA.AP_FECHA_REGISTRO] || fechaDefecto}
              />
            </FormGroup>
          </Col>

          <Col md={5} className='mr-4'>
            <FormGroup>
              <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.AP_FECHA_VENCIMIENTO]} *</Label>
              <Input
                type='date' 
                placeholder='NA'
                onChange={manejadorFechaVencimiento}
                value={programaAcademico[CAMPOS_PROGRAMA.AP_FECHA_VENCIMIENTO] || fechaVencimientoDefecto}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row form>
          <Col md={5} className='mr-4'>
            <FormGroup>
              <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.AP_RESOLUCION]} *</Label>
              <Input
                type='number'
                placeholder='...'
                onChange={manejadorResolucion}
                value={programaAcademico[CAMPOS_PROGRAMA.AP_RESOLUCION] || ''}
              />
            </FormGroup>
          </Col>

          <Col md={5} className='mr-4'>
            <FormGroup>
              <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.AP_ANIOS]} *</Label>
              <Input
                  placeholder='...'
                  type='number'
                  onChange={manejadorAnios}
                  value={programaAcademico[CAMPOS_PROGRAMA.AP_ANIOS] || 0}
                />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col className='mr-4'>
          <FormGroup>
              <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.AP_FILES]} *</Label>
              <div style={{ display: 'flex', gap: '10px'}}>
                <FileUpload
                  id={CAMPOS_PROGRAMA.AP_FILES}
                  onChange={manejadorArchivos}
                  value={programaAcademico[CAMPOS_PROGRAMA.AP_FILES]?.name}
                >
                  {programaAcademico[CAMPOS_PROGRAMA.AP_FILES]?.name}
                </FileUpload>
              </div>
            </FormGroup>
          </Col>
        </Row>
      </Form>

      <div className='mt-3'>
        <Button
          variant='contained'
          color='danger'
          className='mr-2'
          onClick={() => navigation.previous()}
        >
          Atras
        </Button>

        <Button
          variant='contained'
          color='primary'
          onClick={manejadorGuardar}
          disabled={deshabilitarBotonGuardar}
        >
          Guardar
        </Button>
      </div>
    </div>
  )
}
